import React, { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";

const CustomTooltip = ({ children, text, placement = "top" }) => {
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (visible && wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      let top = rect.top;
      let left = rect.left + rect.width / 2;

      if (placement === "top") {
        top = rect.top - 8;
      } else if (placement === "bottom") {
        top = rect.bottom + 8;
      }

      setCoords({ top, left });
    }
  }, [visible, placement]);

  return (
    <div
      className="custom-tooltip-wrapper"
      ref={wrapperRef}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}
      {visible &&
        ReactDOM.createPortal(
          <div
            className={`custom-tooltip-box custom-tooltip-${placement}`}
            style={{ top: coords.top, left: coords.left }}
          >
            {text}
          </div>,
          document.body
        )}
    </div>
  );
};

export default CustomTooltip;
